MS = window.MS || {};
window.$ = window.$ || jQuery;

(function($) {
  MS.productlanding = {
    selectors: {
      animate: 'ms-animate',
      animated: 'ms-animated'
    },
    init: function() {
      var _that = MS.productlanding;

      objectFitImages();
      MS.header.init();
      MS.navigation.init();
      MS.hero.init();
      MS.store_locator.init();
      MS.productlanding_accordion.init();
      MS.productlanding_content_slider.init();
      MS.dropdown.init();
      MS.forms.init();
      MS.tableandsalt_recipe.init(); // for circulation carousel
      MS.productlanding_benefit.init();
      MS.footer.init();

      setTimeout(function(){
        _that.animations();
      }, 800);

      var YTInterval = setInterval(function() {
        if (window.YT) {
          clearInterval(YTInterval);
          _that.loadMediaGallery();
        }
      }, 500);
    },
    loadMediaGallery: function() {
      MS.productlanding_media_gallery.init();
    },
    animations: function() {
      var _this = this;
      $('.' + _this.selectors.animate).each(function() {
        var el = this;
        new Waypoint({
          element: el,
          handler: function(direction) {
            if (direction === 'down') {
              $(el)
                .removeClass(_this.selectors.animate)
                .addClass(_this.selectors.animated);
            }
          },
          offset: '85%'
        });
      });
    }
  };

  $.fn.randomize = function(selector) {
    (selector ? this.find(selector) : this).parent().each(function() {
      $(this)
        .children(selector)
        .sort(function() {
          return Math.random() - 0.5;
        })
        .detach()
        .appendTo(this);
    });
    return this;
  };
})(jQuery);

MS.productlanding.init();
